import React, { useEffect } from 'react';
import { Label, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { fetchDiscountSettings } from 'state/discountSettings/actions';
import PropTypes from 'prop-types';

const ExistingValueTable = props => {
  const { dispatch, discountSettings } = props;

  useEffect(() => {
    dispatch(fetchDiscountSettings());
  }, [dispatch]);

  if (!Array.isArray(discountSettings)) {
    return (
      <div>
        <Label>Loading...</Label>
      </div>
    );
  }

  return (
    <div>
      <Table celled selectable style={{ margin: '0px' }}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Key</Table.HeaderCell>
            <Table.HeaderCell>Value</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {discountSettings.map(discountSetting => (
            <Table.Row key={discountSetting.key}>
              <Table.Cell>{discountSetting.key}</Table.Cell>
              <Table.Cell>{discountSetting.value}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

const mapStateToProps = ({ discountSettings }) => ({
  discountSettings: discountSettings.discountSettings.discountSettings,
});

ExistingValueTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  discountSettings: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ExistingValueTable);
